/** Umstieg einer laufenden Partie auf neuere Spielregeln, nur zwischen zwei Legislaturen und nur im Einzelspieler. */
import { S, log } from './state';
import { RULES, RULE_NOTES, verOf } from './version';

/** Kann die laufende Partie jetzt auf die aktuellen Regeln umsteigen? */
export const canUpgrade = (): boolean => !!S && !S.mp && S.phase === 'review' && verOf(S) < RULES;

/** Neue Regeln übernehmen. `to` steht im Zugprotokoll, damit ein späteres Nachspielen dieselbe Version wählt. */
export function upgradeRules(to: number) {
  if (S.mp || S.phase !== 'review') return;
  const from = verOf(S);
  if (!Number.isInteger(to) || to <= from || to > RULES) return;
  S.ver = to;
  const notes = Object.keys(RULE_NOTES).map(Number).filter((v) => v > from && v <= to).flatMap((v) => RULE_NOTES[v]);
  log(`Neue Spielregeln ab der nächsten Legislatur: ${notes.join(' ')}`, 'good');
}
